import React, { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";

import CrudForm, { FormConfiguration } from "../shared/crud/form";
import { withAuthorizationVerifier } from "../../components/authorization-verifier";
import actions from "../../lib/actions";
import {
  getTaxConfiguration,
  updateTaxConfiguration,
} from "../shared/api/taxConfiguration/infrastructure/taxConfiguration.api";
import { useProperty } from "../../components/property-provider";
import { TaxConfigurationEntity } from "../shared/api/taxConfiguration/domain/taxConfiguration.entity";
import { messages } from "./taxConfiguration.messages";
import { buildFormConfiguration, buildSchema } from "./taxConfiguration.formConfig";

function TaxConfigurationForm() {
  const intl = useIntl();
  const propertyInfo = useProperty();

  const handleGetOne = useCallback(async () => {
    return getTaxConfiguration(propertyInfo.token);
  }, [propertyInfo.token]);

  const handleUpdate = useCallback(
    async (entity: TaxConfigurationEntity) => {
      await updateTaxConfiguration(entity, propertyInfo.token);
      alert(intl.formatMessage(messages.saveSuccess));
    },
    [intl, propertyInfo.token]
  );

  const { formConfiguration, schema } = useMemo<{
    formConfiguration: FormConfiguration<TaxConfigurationEntity>;
    schema: any;
  }>(
    () => ({
      schema: buildSchema(intl),
      formConfiguration: buildFormConfiguration(),
    }),
    [intl]
  );

  return (
    <CrudForm<TaxConfigurationEntity>
      id={"tax"}
      schema={schema}
      formConfiguration={formConfiguration}
      messages={messages}
      onGet={handleGetOne}
      onUpdate={handleUpdate}
      canUpdate={actions.ModifyTaxConfiguration}
      enumsOptional
    />
  );
}
export default withAuthorizationVerifier(TaxConfigurationForm);
